require('./openYoungHistoryFilter.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
//@utilities
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatCurrency } = require('utilities/currencyHelper');
//@commons
const { AmountFilter } = require('commonsComponents/amountFilter');
const DateFilter = require('components/commons/dateFilter/dateFilter');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const OKModal = require('components/commons/OKModal/OKModal');
// @ constants
const { EURO_TEXT } = require('constants/index');
const { AMOUNT_FILTER_LABEL, AMOUNT_FILTER_GREATER_THAN, AMOUNT_FILTER_LOWER_THAN } = require('constants/commonsComponents');
const { requestStatus } = require('constants/openYoungHistory');

class OpenYoungHistoryFilter extends React.Component {
    constructor(props) {
        super(props);

        const { immFilters } = props;
        this.state = {
            amountFrom: immFilters.getIn(['amount','from','amount']),
            amountTo: immFilters.getIn(['amount','to','amount']),
            childsPan: immFilters.getIn(['childList','childsPan']).toJS(),
            dateFrom: immFilters.getIn(['date', 'from']),
            dateSelected: immFilters.getIn(['date', 'selected']),
            dateTo: immFilters.getIn(['date', 'to']),
            statusList: requestStatus(),
            statusSelected: immFilters.getIn(['status', 'status']),
        };

        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeAmountMax = this.handleChangeAmountMax.bind(this);
        this.handleChangeAmountMin = this.handleChangeAmountMin.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleChildClick = this.handleChildClick.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.buildChildFilter = this.buildChildFilter.bind(this);
    }

    handleChangeAmountMax(amountTo) {
        this.setState({amountTo});
    }

    handleChangeAmountMin(amountFrom) {
        this.setState({amountFrom});
    }

    handleChangeDateMax(dateTo) {
        this.setState({dateTo});
    }

    handleChangeDateMin(dateFrom) {
        this.setState({dateFrom});
    }

    handleChangeDateSelected(dateSelected) {
        this.setState({dateSelected});
    }

    handleOnSubmit() {
        const {
            accountCurrency,
            amountFrom,
            amountTo,
            childsPan,
            dateFrom,
            dateSelected,
            dateTo,
            statusSelected,
        } = this.state;
        this.props.onFilterSubmitClick({
            date: {
                selected: dateSelected,
                from: dateFrom,
                to: dateTo
            },
            status: {
                status: statusSelected
            },
            childList: {
                isActive: childsPan.filter(pan => pan['isSelected']).length > 0,
                childsPan
            },
            amount: {
                from: {
                    currency: accountCurrency,
                    amount: amountFrom
                },
                to: {
                    currency: accountCurrency,
                    amount: amountTo
                }
            },
        });
        this.props.onCloseClick();
    }

    handleStatusChange(value) {
        this.setState({
            statusSelected: value.value
        });
    }

    handleChildClick(index) {
        const { childsPan } = this.state;
        const { immOpenYoungChildDetails } = this.props;
        const pan = immOpenYoungChildDetails.getIn([index.target.id, 'pan']);
        const childIndex = childsPan.findIndex((child) => child.pan === pan);
        let isSelected = true;
        if (childIndex !== -1) {
            childsPan[childIndex].isSelected = !childsPan[childIndex].isSelected;
        } else {
            childsPan.push({pan, isSelected: isSelected});
        }
        this.setState({childsPan});
    }

    buildChildFilter(immOpenYoungChildDetails) {
        let childComponent;
        const { childsPan } = this.state;
        if (!!immOpenYoungChildDetails.size) {
            childComponent = immOpenYoungChildDetails.map((child, index) => {
                let isSelected = false;
                const childIndex = childsPan.findIndex((childList) => childList.pan === child.get('pan'));
                if (childIndex !== -1) {
                    isSelected = childsPan[childIndex].isSelected;
                }
                const classNames = classnames(
                    'openyoung-history-filter__child',
                    {
                        'openyoung-history-filter__child--selected':  isSelected
                    }
                );
                return (
                    <div key={index} id={index} className={classNames} onClick={(evt) => this.handleChildClick(evt)}>
                        {child.get('childName')}
                    </div>
                )
            })
            return (
                <div className="openyoung-history-filter__child-list">
                    <div className="openyoung-history-filter date-filter__title">
                        <FormattedText format="firstUppercase" value="openYoungHistoryFilter-child" />
                    </div>
                    {childComponent}
                </div>
            );
        }
    }


    buildStatusFilter() {
        return (
            <div className="row">
                <div className="openyoung-history-filter__status col-xs-6">
                    <FormattedText
                        className="openyoung-history-filter date-filter__title" 
                        format="firstUppercase" 
                        value="openYoungHistoryFilter-status" 
                    />
                    <OKSelect
                        clearable={false}
                        name="history-status-filter-dropdown"
                        onChange={this.handleStatusChange}
                        openUp={true}
                        options={this.state.statusList}
                        searchable={false}
                        value={this.state.statusSelected}
                    />
                </div>
            </div>
        );
    }

    render() {
        const { 
            immFilters,
            immOpenYoungChildDetails,
            isOpen,
            onCloseClick,
        } = this.props;
        const { amountFrom, amountTo } = this.state;
        const statusFilter = this.buildStatusFilter();
        const childFilter = this.buildChildFilter(immOpenYoungChildDetails);
        const contentModal = (
            <div className="openyoung-history-filter__date-filter-wrapper">
                {childFilter}
                <DateFilter
                    immFilter={immFilters.get('date')}
                    onChangeMin={this.handleChangeDateMin}
                    onChangeMax={this.handleChangeDateMax}
                    onChangeSelected={this.handleChangeDateSelected}
                    showAnnual={false}
                />
                <AmountFilter
                    immFilter={immFilters}
                    onChangeMin={this.handleChangeAmountMin}
                    onChangeMax={this.handleChangeAmountMax}
                    fromValue={amountFrom}
                    toValue={amountTo}
                    currencySymbol={formatCurrency(EURO_TEXT)}
                    amountLabel={AMOUNT_FILTER_LABEL}
                    greaterThan={AMOUNT_FILTER_GREATER_THAN}
                    lowerThan={AMOUNT_FILTER_LOWER_THAN}
                    language={getLanguage()}
                />
                {statusFilter}
            </div>
        );
        return (
            <OKModal
                content={contentModal}
                footerType="navigation"
                isOpen={isOpen}
                onCloseCallback={onCloseClick}
                onPrimaryButtonClick={this.handleOnSubmit}
                onSecondaryButtonClick={onCloseClick}
                primaryButtonText="filterDate-apply"
                secondaryButtonText="filterDate-cancel"
                title="cards-filterMovements"
                type="filter"
            />
        );
    }
}

OpenYoungHistoryFilter.propTypes = {
    immFilters: PropTypes.object.isRequired,
    immOpenYoungChildDetails: PropTypes.array.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    onFilterSubmitClick: PropTypes.func.isRequired,
};

module.exports = OpenYoungHistoryFilter;
